<script>
    import Box from './Box.svelte'
    import Icon from 'fa-svelte'
    import { faHeart as heart } from '@fortawesome/free-solid-svg-icons/faHeart'
    import { faCheck as check } from '@fortawesome/free-solid-svg-icons/faCheck'
    import { faPaperPlane as paperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane'
</script>

<style>

    icon {
        vertical-align: middle;
    }

    .purple {
        color: #7539ff;
    }

    grid {
        display: grid;
        grid-column-gap: 1rem;
        grid-template-columns: minmax(12rem, auto) minmax(auto, 12rem);
        align-items: top;
    }

    a {
        float: right;
        width: 12rem;
        padding: 0;
    }

</style>

<Box hoverable={false}>
    <h1>
        <a href="https://www.producthunt.com/posts/stuck-home?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-stuck-home" target="_blank">
            <img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=196890&theme=dark" alt="🏠 Stuck Home - The crowdsourced list of fun things to do from home! | Product Hunt Embed" style="width: 100%" />
        </a>
    </h1>
    <h1>🏠 Stuck Home</h1>
    <p>Here’s a crowdsourced list of <strong>fun things to do</strong> while you're home!</p>

    <!-- <p>Mark activity as done <icon class='purple'><Icon icon={check}></Icon></icon> or save it for later <icon class='red'><Icon icon={heart}></Icon></icon>, and of course, submit your own <icon><Icon icon={paperPlane}></Icon></icon>!</p> -->
</Box>


<!-- <Box>
    <h1>🏠 StuckHome.io</h1>
    <p>Well. It looks like we’re stuck home for a while. 😅<br>
    Here’s a crowdsourced list of a few <strong>things you could do remotely with friends</strong>.</p>

    <span slot='accessory'><button class='primary'>Submit idea</button></span>
</Box> -->
